const state = {
  userInfo: null, // 用户信息
  labelList: [], // 页签数据
  menuList: [],
  openKeys: [], // 展开菜单
  selectedKeys: [], // 选中菜单
  collapsed: false, // 菜单折叠
  locale: 'zh', // 国际化
};

export default state;
